import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, createTextVNode as _createTextVNode, withModifiers as _withModifiers, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "mt-1" }
const _hoisted_2 = { class: "space-y-1" }
const _hoisted_3 = { class: "mt-1" }
const _hoisted_4 = { class: "flex items-center justify-between" }
const _hoisted_5 = { class: "flex items-center" }

import { ref } from "vue";
import { client } from "@/shared";
import { Authenticate } from "@/dtos";
import ErrorSummary from "@/main/components/ErrorSummary.vue";
import SaButton from "@/main/components/SaButton.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'SignIn',
  props: {
    redirect: {}
  },
  setup(__props: any) {

const props = __props;

const email = ref("");
const password = ref("");
const rememberMe = ref(false);
const responseStatus = ref(null);

const isSubmitting = ref(false);
const submit = async () => {
  isSubmitting.value = true;
  const redirect = props.redirect || "/";

  try {
    await client.post(
      new Authenticate({
        userName: email.value,
        password: password.value,
        rememberMe: rememberMe.value,
        provider: "credentials",
        meta: { redirect }
      })
    );
    window.location.href = redirect;
  } catch (e: any) {
    responseStatus.value = e.responseStatus || {
      errorCode: "Unknown",
      message: "An error occurred"
    };
  } finally {
    isSubmitting.value = false;
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("form", {
    onSubmit: _withModifiers(submit, ["prevent"]),
    class: "space-y-6"
  }, [
    _createVNode(ErrorSummary, { "response-status": responseStatus.value }, null, 8, ["response-status"]),
    _createElementVNode("div", null, [
      _cache[3] || (_cache[3] = _createElementVNode("label", {
        for: "email",
        class: "block text-sm font-medium text-clay-950"
      }, " Email address ", -1)),
      _createElementVNode("div", _hoisted_1, [
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((email).value = $event)),
          id: "email",
          name: "email",
          type: "email",
          autocomplete: "email",
          required: "",
          class: "block w-full rounded-lg border border-transparent shadow-sm ring-1 ring-black/10 px-[calc(theme(spacing.2)-1px)] py-[calc(theme(spacing[1.5])-1px)] text-clay-950 sm:text-sm/6 data-[focus]:outline data-[focus]:outline-2 data-[focus]:-outline-offset-1 data-[focus]:outline-black"
        }, null, 512), [
          [_vModelText, email.value]
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_2, [
      _cache[4] || (_cache[4] = _createElementVNode("label", {
        for: "password",
        class: "block text-sm font-medium text-clay-950"
      }, " Password ", -1)),
      _createElementVNode("div", _hoisted_3, [
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((password).value = $event)),
          id: "password",
          name: "password",
          type: "password",
          autocomplete: "current-password",
          required: "",
          class: "block w-full rounded-lg border border-transparent shadow-sm ring-1 ring-black/10 px-[calc(theme(spacing.2)-1px)] py-[calc(theme(spacing[1.5])-1px)] text-clay-950 sm:text-sm/6 data-[focus]:outline data-[focus]:outline-2 data-[focus]:-outline-offset-1 data-[focus]:outline-black"
        }, null, 512), [
          [_vModelText, password.value]
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((rememberMe).value = $event)),
          id: "remember-me",
          name: "remember-me",
          type: "checkbox",
          class: "w-4 h-4 rounded border-clay-300 text-clay-800 focus:ring-clay-500"
        }, null, 512), [
          [_vModelCheckbox, rememberMe.value]
        ]),
        _cache[5] || (_cache[5] = _createElementVNode("label", {
          for: "remember-me",
          class: "block ml-2 text-sm text-clay-900"
        }, " Remember me ", -1))
      ]),
      _cache[6] || (_cache[6] = _createElementVNode("div", { class: "text-sm" }, [
        _createElementVNode("a", {
          href: "/forgot-password",
          class: "font-medium text-clay-800 hover:text-clay-900"
        }, " Forgot your password? ")
      ], -1))
    ]),
    _createElementVNode("div", null, [
      _createVNode(SaButton, {
        type: "submit",
        onClick: _withModifiers(submit, ["prevent"]),
        loading: isSubmitting.value,
        variant: "primary"
      }, {
        loading: _withCtx(() => _cache[7] || (_cache[7] = [
          _createTextVNode(" Signing in... ")
        ])),
        default: _withCtx(() => [
          _cache[8] || (_cache[8] = _createTextVNode(" Sign in "))
        ]),
        _: 1
      }, 8, ["loading"])
    ])
  ], 32))
}
}

})